export { default as MaterialsCategoriesFilterBadge } from './MaterialsCategoriesFilterBadge';
